module.exports = __webpack_public_path__ + "static/media/sdg3.fee81e25.png";